import { WebComponent } from '@cian/mf-registry/browser';
import { hydrateRoot, createRoot } from 'react-dom/client';

import { Application } from '../../../shared/mf-my-home/containers/App';
import { IApplicationContext } from '../../../shared/mf-my-home/types/applicationContext';
import { TReduxStore } from '../../../shared/mf-my-home/types/redux';

export function createCustomElementConstructor(
  context: IApplicationContext,
  store: TReduxStore,
): CustomElementConstructor {
  class MyHome extends WebComponent {
    private applicationContext: IApplicationContext;

    protected microfrontendName = context.config.getStrict<string>('projectName');
    protected imageVersion = context.config.getStrict<string>('version.commit');
    protected runtimeName = '/public/v1/get-my-home-microfrontend/';

    public async connectedCallback(): Promise<void> {
      const s = super.connectedCallback();
      this.applicationContext = { ...context, config: context.config.attach({ instanceId: this.instance.id }) };

      return s;
    }

    public async render() {
      const reactElement = <Application {...this.props} context={this.applicationContext} reduxStore={store} />;

      if (this.shouldHydrate) {
        hydrateRoot(this, reactElement);
      } else {
        createRoot(this).render(reactElement);
      }
    }
  }

  return MyHome;
}
